import React from 'react'
import { useSelector } from 'react-redux'
import Card from '../../../components/Layouts/Card'
import Typography from '../../../components/Basics/Typography'
import { ChartBarStacked, BoxPlot, HeatMap } from '@carbon/icons-react'
import { CardComponent, CardRow } from '../../../components/Layouts/Card.styles'
import Gauge from '../../../components/Graphs/Gauge.container'
import Histogram from '../../../components/Graphs/Histogram.container'
import HorizontalBoxPLot from '../../../components/Graphs/HorizontalBoxPlot.container'
import LineGraph from '../../../components/Graphs/LineChart.container'
import GroupBarChart from '../../../components/Graphs/GroupBarChart.container'
import FlexHeatMap from '../../../components/Graphs/FlexHeatMap.container'
import { spacing05 } from "@carbon/themes";
import InformationContainer from '../../../components/Basics/Information.container'
import { convertTo12HourFormat } from '../../../components/Graphs/utils'

export const FirstRow = () => {
  const { monthlyProduction, m3Production, monthlyProductionBefore } = useSelector(state => state.monthly)
  let monthlyProductionData = monthlyProductionBefore.value
  const change = `${monthlyProduction - monthlyProductionData}`
  const gaugeStatus = monthlyProduction > monthlyProductionData ? 'success' : 'danger'

  const axis = {
    left: {
      scaleType: 'labels',
      mapsTo: 'key'
    },
    bottom: {
      mapsTo: 'value'
    }
  }

  return (
    <CardComponent width="100%">
      <Card justifyContent='flex-start' >
        <ChartBarStacked size={18} />
        <Typography className='cds--type-heading-compact-01'>
          PRODUCCIÓN MES
        </Typography>
      </Card>
      <InformationContainer description='Solo se mostrarán los frentes que recibieron descargas durante el mes del reporte.' />
      <CardRow width='inherit'>
        <Card flexDirection='column' justifyContent='center' width="17%" padding={spacing05}>
          <Gauge title='Producción Mensual' footer="Comparación con Mes Anterior" percentage={monthlyProduction} change={change} maxPercent={17000} noMetric={true} arrowStatus={gaugeStatus} />
        </Card>
        <Card flexDirection='column' justifyContent='center' width="83%" padding={spacing05}>
          <GroupBarChart title='Producción por Frentes de Descarga (total, m3)' height='35rem' data={m3Production} axesOptions={axis} />
        </Card>
      </CardRow>
    </CardComponent>
  )
}

export const SecondRow = () => {
  const { loadCount, loadTime } = useSelector(state => state.monthly)

  return (
    <CardComponent width="100%">
      <Card justifyContent='flex-start' >
        <ChartBarStacked size={18} />
        <Typography className='cds--type-heading-compact-01'>
          CARGAS
        </Typography>
      </Card>
      <InformationContainer description='Únicamente se visualizarán las plataformas que registraron cargas.' />
      <CardRow width='inherit'>
        <Card flexDirection='column' justifyContent='center' width="100%" padding={spacing05}>
          <LineGraph title='Cargas Completadas (total, cargas)' height='20rem' lineData={loadCount} />
        </Card>
      </CardRow>
      <CardRow width='inherit'>
        <Card flexDirection='column' justifyContent='center' width="100%" padding={spacing05}>
          <LineGraph title='Duración de Carga (media, minutos)' height='20rem' lineData={loadTime} />
        </Card>
      </CardRow>
    </CardComponent>
  )
}

export const ThirdRow = () => {
  const { discharge, wallTime } = useSelector(state => state.monthly)

  return (
    <CardComponent width="100%">
      <Card justifyContent='flex-start' >
        <ChartBarStacked size={18} />
        <Typography className='cds--type-heading-compact-01'>
          DESCARGAS
        </Typography>
      </Card>
      <InformationContainer description='Solo se mostrarán los frentes que recibieron descargas durante el mes del reporte.' />
      <CardRow width='inherit'>
        <Card flexDirection='column' justifyContent='center' width="100%" padding={spacing05}>
          <LineGraph title='Descargas (total, descargas)' height='20rem' lineData={discharge} />
        </Card>
      </CardRow>
      <CardRow width='inherit'>
        <Card flexDirection='column' justifyContent='center' width="100%" padding={spacing05}>
          <LineGraph title='Tiempo en Muros de  Descargas (media, minutos)' height='20rem' lineData={wallTime} />
        </Card>
      </CardRow>
    </CardComponent>
  )
}

export const FourthRow = () => {
  const { queueTimes } = useSelector(state => state.monthly)

  const axis = {
    left: {
      scaleType: 'labels',
      mapsTo: 'key'
    },
    bottom: {
      mapsTo: 'value'
    }
  }
  return (
    <>
      <CardComponent width="100%">
        <Card justifyContent='flex-start' >
          <ChartBarStacked size={18} />
          <Typography className='cds--type-heading-compact-01'>
            COLAS EN MURO Y PLATAFORMAS - MINUTOS
          </Typography>
        </Card>
        <InformationContainer description='Las colas corresponden al promedio de pérdida operacional generada por la espera en la cola.' />
        <CardRow width='inherit'>
          <Card flexDirection='column' justifyContent='center' width="100%" padding={spacing05}>
            <GroupBarChart title='Colas en Frentes de Descarga y Excavadoras (media, minutos)' height='35rem' data={queueTimes} axesOptions={axis} />
          </Card>
        </CardRow>
      </CardComponent>
    </>
  )
}

export const FifthRow = () => {
  const { prodHours, numberTrucks, maintenance, meanCyclePerTurn, prodHoursIdle, m3Moved } = useSelector(state => state.monthly)
  console.log(numberTrucks)
  return (
    <CardComponent width="100%">
      <Card justifyContent='flex-start' >
        <ChartBarStacked size={18} />
        <Typography className='cds--type-heading-compact-01'>
          RENDIMIENTO DE TRANSPORTE
        </Typography>
      </Card>
      <CardRow width='inherit'>
        <Card flexDirection='column' justifyContent='center' width="100%" padding={spacing05}>
          <LineGraph title='Tiempo Efectivo (media, horas)' height='20rem' lineData={prodHours} />
        </Card>
      </CardRow>
      <CardRow width='inherit'>
        <Card flexDirection='column' justifyContent='center' width="50%" padding={spacing05}>
          <LineGraph title='Camiones Operativos' height='20rem' lineData={numberTrucks} />
        </Card>
        <Card flexDirection='column' justifyContent='center' width="50%" padding={spacing05}>
          <LineGraph title='Tiempo fuera de servicio (media, horas)' height='20rem' lineData={maintenance} />
        </Card>
      </CardRow>
      <CardRow width='inherit'>
        <Card flexDirection='column' justifyContent='center' width="50%" padding={spacing05}>
          <LineGraph title='Ciclos (media, ciclos)' height='20rem' lineData={meanCyclePerTurn} />
        </Card>
        <Card flexDirection='column' justifyContent='center' width="50%" padding={spacing05}>
          <LineGraph title='Tiempo en ralenti (media,horas)' height='20rem' lineData={prodHoursIdle} />
        </Card>
      </CardRow>
      <CardRow width='inherit'>
        <Card flexDirection='column' justifyContent='center' width="100%" padding={spacing05}>
          <LineGraph title='M3 Movido (media, m3)' height='20rem' lineData={m3Moved} />
        </Card>
      </CardRow>
    </CardComponent>
  )
}

export const SixthRow = () => {
  const { goodStart, ending, startCycle, breakFast } = useSelector(state => state.monthly)

  const axis = {
    bottom: {
      scaleType: "linear",
      title: 'Hora',
      mapsTo: 'value',
      bins: 24,
      domain: [8, 32],
      ticks: {
        values: [8, 11, 14, 17, 20, 23, 26, 29, 32],
        formatter: (value, i) => {
          // Convert the transformed value back to the original hour
          const formattedStart = convertTo12HourFormat(value);
          
          const formattedValue = `${formattedStart}`;
          return formattedValue
        }
      }
    },
    left: {
      title: 'Valor',
      scaleType: 'lineal',
      binned: true
    }
  }

  const legend = {
    order: ["Turno Día", "Turno Noche"]
  }

  const getFillColor = (group) => {
    const turnoDia = legend.order[0];
    return group === turnoDia ? "#8a3ffc" : "#009d9a"
  }

  return (
    <CardComponent width="100%">
      <Card justifyContent='flex-start' >
        <BoxPlot size={18} />
        <Typography className='cds--type-heading-compact-01'>
          TIEMPOS DE JORNADA - HISTOGRAMA
        </Typography>
      </Card>
      <InformationContainer description='Cada barra en el histograma representa la cantidad de conductores en un intervalo específico de una hora.' />
      <CardRow width='inherit'>
        <Card flexDirection='column' justifyContent='center' width="100%" padding={spacing05}>
          <Histogram title='Hora Inicio Efectivo (total, conductores)' data={goodStart} axesOptions={axis} legendOptions={legend} getFillColor={getFillColor} />
        </Card>
        <Card flexDirection='column' justifyContent='center' width="100%" padding={spacing05}>
          <Histogram title='Hora Término Efectivo (total, conductores)' data={ending} axesOptions={axis} legendOptions={legend} getFillColor={getFillColor} />
        </Card>
      </CardRow>
      <CardRow width='inherit'>
        <Card flexDirection='column' justifyContent='center' width="100%" padding={spacing05}>
          <Histogram title='Inicio Primer Ciclo (total, conductores)' data={startCycle} axesOptions={axis} legendOptions={legend} getFillColor={getFillColor} />
        </Card>
        <Card flexDirection='column' justifyContent='center' width="100%" padding={spacing05}>
          <HorizontalBoxPLot title='Duración Colación (media, minutos)' data={breakFast} />
        </Card>
      </CardRow>
    </CardComponent>
  )
}

export const SeventhRow = () => {
  const { cycleTime, heatmapHour, avgSpeed, cycleCount } = useSelector(state => state.monthly)
  const graphWidth = "100%"


  return (
    <>
      <CardComponent width="100%">
        <Card justifyContent='flex-start' >
          <HeatMap size={18} />
          <Typography className='cds--type-heading-compact-01'>
            RUTAS DE TRANSPORTE
          </Typography>
        </Card>
        <InformationContainer description='Las rutas corresponden al rendimiento de los camiones en los ciclos registrados.' />
        <InformationContainer description='Se compara el rendimiento del mes seleccionado con el rendimiento del mes anterior.' />
        <CardRow>
          <Card flexDirection='column' justifyContent='center' width={graphWidth} padding={spacing05}>
            <FlexHeatMap data={cycleTime} title='Duración de Ciclos (media, minutos)' changeColor={true}/>
          </Card>
        </CardRow>
        <CardRow>
          <Card flexDirection='column' justifyContent='center' width={graphWidth} padding={spacing05}>
            <FlexHeatMap data={cycleCount} title='Cantidad de Ciclos (media, ciclos)' />
          </Card>
        </CardRow>
        <CardRow>
          <Card flexDirection='column' justifyContent='center' width={graphWidth} padding={spacing05}>
            <FlexHeatMap data={avgSpeed} title='Velocidad Promedio (media, km/h)' />
          </Card>
        </CardRow>
        <CardRow>
          <Card flexDirection='column' justifyContent='center' width={graphWidth} padding={spacing05}>
            <FlexHeatMap data={heatmapHour} title='M3 por Hora (media, m3/h)' />
          </Card>
        </CardRow>
      </CardComponent>
    </>
  )
}
